$( document ).ready(function() {
var cust_id= document.getElementById('customer_number').innerHTML;
  
var cust_id = cust_id.replace("<a href=\"javascript: void(0)\">", "");
 var cust_id = cust_id.replace("</a>", ""); 

  var pidexists=document.getElementById('product_id'); 
  if (pidexists){
  var product_id= document.getElementById('product_id').innerHTML;
    var product_id = product_id.replace("<a href=\"javascript: void(0)\">", "");
    var product_id = product_id.replace("</a>", ""); 
  }

var disp_atc_btn=1; 

   var atcexists2=document.getElementById('atc');
  if (atcexists2 ){

    var atcpage=1;
  }else{
     var atcpage=0;
  }
  
  if (cust_id.length>0){
  
 jQuery.getJSON('/cart.js', function(cart) {
   var cart_count=cart.items.length;
  var formattedCartData = [];
  //document.getElementById("cartcount").innerHTML=cart_count;
  var var_list='';
  var disp_atc_btn=1; 
   if (cart_count>0){
     
    for (var i = 0, len = cart_count; i < len; i++) {
      
      var var_list=var_list+cart.items[i]['variant_id']+'|';

      if (product_id){ 
        
       if (cart.items[i]['product_id']==product_id){
var cartItemPair = {
            variant_id: cart.items[i]['variant_id'], // Shopify's cart.js provides the numeric variant_id
            variant_quantity: cart.items[i]['quantity']// Shopify's cart.js provides the quantity
          };
formattedCartData.push(cartItemPair);
         
        var atcexists=document.getElementById('atc'); 
        if (atcexists){
        //document.getElementById('atc').style.display="none";
        }
         var iccexists=document.getElementById('in_cart');
         var orgvarexists=document.getElementById('orig_var'); 
        if (iccexists){ 
          if (orgvarexists){
          document.getElementById('orig_var').innerHTML=cart.items[i]['variant_id'];
          }
         document.getElementById('in_cart').style.display="block";
          var disp_atc_btn=0;
         
          
        }
      }
      }
     
   // alert(disp_atc_btn)
    
      
    }
  var variant_json = JSON.stringify(formattedCartData);  


 var vjexists=document.getElementById('var_json'); 
        if (vjexists){
        document.getElementById('var_json').innerHTML=variant_json;
        }

     
   }else{
     
    var var_list="na"; 
    
   }

   
if (typeof point_sale_atc_display === 'function') {

  point_sale_atc_display(disp_atc_btn);

}else{
if (disp_atc_btn==1 && atcpage==1){
document.getElementById('atc').style.display="block";
  
} 
 }

});   
    
    
    
    
  }
  

  
  
});




//$( document ).ready(function() {

function point_sale_atc_display(cart_check){

  //alert(cart_check)
  var product_id= document.getElementById('product_id').innerHTML;
    var product_id = product_id.replace("<a href=\"javascript: void(0)\">", "");
    var product_id = product_id.replace("</a>", ""); 

   var cust_id= document.getElementById('customer_number').innerHTML;
    var cust_id = cust_id.replace("<a href=\"javascript: void(0)\">", "");
    var cust_id = cust_id.replace("</a>", ""); 

  $.post("https://buylocalus.com/apps/blusapp/check_bwp_init.php",{product_id:product_id,cust_id:cust_id},function(data){
   // alert(data)
var arr=JSON.parse(data);
var date_flag=arr['date_flag'];
var sold_out=arr['sold_out'];

    var atc_show=1;

      if (date_flag==1){
         var atc_show=0;
      if (document.getElementById('na_reason')){
   document.getElementById('na_reason').innerHTML="This promo has not yet started.";
     document.getElementById('na_reason').style.display="block";
        //document.getElementById('atc').style.display="none";
      }
      }
        
   if (date_flag==2){
      var atc_show=0;
      if (document.getElementById('na_reason')){
    document.getElementById('na_reason').innerHTML="This promo has ended.";
     document.getElementById('na_reason').style.display="block";
         //document.getElementById('atc').style.display="none";
      }
   }

         if (sold_out==1){
            var atc_show=0;
      if (document.getElementById('psp_sold_out')){
   document.getElementById('psp_sold_out').innerHTML="This promo has sold out.";
     document.getElementById('psp_sold_out').style.display="block";
        //document.getElementById('atc').style.display="none";
      }
         }

     if (sold_out==2){
        var atc_show=0;
      if (document.getElementById('psp_sold_out')){
   document.getElementById('psp_sold_out').innerHTML="You have reached your limit for this promo.";
     document.getElementById('psp_sold_out').style.display="block";
        //document.getElementById('atc').style.display="none";
      }
         }

         if (sold_out==3){
        var atc_show=0;
      if (document.getElementById('psp_sold_out')){
   document.getElementById('psp_sold_out').innerHTML="This promotion is for new customers only. You have already received promos from this business.";
     document.getElementById('psp_sold_out').style.display="block";
        //document.getElementById('atc').style.display="none";
      }
         }

   

   
    if (atc_show==1 && cart_check==1){ 
      if (document.getElementById('atc')){
document.getElementById('atc').style.display="block";
      }
    }

  })

}
//});



document.addEventListener('DOMContentLoaded', () => {
    const myButton = document.getElementById('atc');

    if (myButton) {
      myButton.addEventListener('click', () => {
        // Access productSettings directly within this event listener function
    if (productSettings){

   

   const email_required = productSettings.email_required
   const email_requested = productSettings.email_requested
   const text_input_required = productSettings.text_input_required
   const text_input_type = productSettings.text_input_type
   const checkbox1_required = productSettings.checkbox1_required
   const checkbox2_required = productSettings.checkbox2_required
   const text_input = document.getElementById('promo_ti');
   const checkbox1 = document.getElementById('checkbox1');
   const checkbox2 = document.getElementById('checkbox2');
   const text_input_err = document.getElementById('promo_ti_err');
   const checkbox1_err = document.getElementById('checkbox1_err');
   const checkbox2_err = document.getElementById('checkbox2_err');

   var ti_error=0;
   var cb1_error=0;
   var cb2_error=0;
   var all_error=0;
   var cb1_checked=0; 
   var cb2_checked=0; 


    if (text_input_err){
   document.getElementById('promo_ti_err').style.display='none'; 
    }
  

  
    if (checkbox1_err){
   document.getElementById('checkbox1_err').style.display='none'; 
    }
  

  
    if (checkbox2_err){
   document.getElementById('checkbox2_err').style.display='none'; 
    }
     
  
    

    
   if (text_input){
     var text_input_val=document.getElementById('promo_ti').value;
     if (text_input_required==1){
       if (text_input_val.length==0){
         var ti_error=1;
         var all_error=1;
       }       
     }
     
   }else{
    var text_input_val='';  
   }


   

   if (checkbox1){
    
     if (checkbox1_required==1){
       if (checkbox1.checked){
         var cb1_checked=1;  
         
       }else{
         var cb1_error=1;
         var all_error=1;
       }       
     }else{
       if (checkbox1.checked){
         var cb1_checked=1;  
         
       }       
     }
     
   }

    if (checkbox2){
    
     if (checkbox2_required==1){
       if (checkbox2.checked){
         var cb2_checked=1;  
         
       }else{
         var cb2_error=1;
         var all_error=1;
       }       
     }else{
       if (checkbox2.checked){
         var cb2_checked=1;  
         
       }       
     }
     
   }   

      

if (all_error==1){
  if (ti_error==1){
    if (text_input_err){
   document.getElementById('promo_ti_err').style.display='block'; 
    }
  }

  if (cb1_error==1){
    if (checkbox1_err){
   document.getElementById('checkbox1_err').style.display='block'; 
    }
  }

  if (cb2_error==1){
    if (checkbox2_err){
   document.getElementById('checkbox2_err').style.display='block'; 
    }
  }

  
}else{
  /// process click

  if (email_requested==1){ 
     document.getElementById("closebtn").style.display="none" ;
document.getElementById("modal_head").innerHTML="<br><center>Would you like to share your email with this business for additional offers and info?<br><br></center>";     
     document.getElementById("modal_desc").innerHTML="";
    document.getElementById('yesbtn').setAttribute('onclick','process_promo(' + JSON.stringify(text_input_val) + ',' + cb1_checked + ',' + cb2_checked + ',1)');  

    
       document.getElementById('nobtn').setAttribute('onclick','process_promo(' + JSON.stringify(text_input_val) + ',' + cb1_checked + ',' + cb2_checked + ',0)');            
                   document.getElementById("ynbtns").style.display="block" ; 
                  toggleModal();
  }else if (email_required==1){
     document.getElementById("closebtn").style.display="none" ;
 document.getElementById("modal_head").innerHTML="<br><center>This business requires an email address to continue. May we share your email address with them?<br><br></center>";   
 document.getElementById("modal_desc").innerHTML="";
    document.getElementById('yesbtn').setAttribute('onclick','process_promo(' + JSON.stringify(text_input_val) + ',' + cb1_checked + ',' + cb2_checked + ',1)');
                   document.getElementById("ynbtns").style.display="block" ; 
                               toggleModal();
  }else{

    process_promo(text_input_val,cb1_checked,cb2_checked,0);
    
  }
  
}
      
 }else{
   alert('There was an issue with your submission. Please refresh the page and try again.')
 }
      });
    }
  });

const TARGET_URL = 'https://buylocalus.com/apps/blusapp/process_promo.php';
async function process_promo(text_input,checkbox1,checkbox2,save_email){
 //alert(text_input+'-'+checkbox1+'-'+checkbox2+'-'+save_email) 
 document.getElementById('atc').style.display="none";
  document.getElementById('spinner').style.display="block";
 var product_id='';
 var cust_id='';
 var saved_collection_id='';


 var pidexists=document.getElementById('product_id'); 
  if (pidexists){
  var product_id= document.getElementById('product_id').innerText;
  }

  var cidexists=document.getElementById('customer_number'); 
  if (cidexists){
  var cust_id= document.getElementById('customer_number').innerText;
  }

  var colidexists=document.getElementById('collection_id'); 
  if (colidexists){
  var saved_collection_id= document.getElementById('collection_id').innerText;
  }

  var ovexists=document.getElementById('owner_viewing'); 
  if (ovexists){
  var owner_viewing=1;
  }else{
var owner_viewing=0;

  }

  


 const formData = new FormData();
    formData.append('text_input', text_input);
    // Convert boolean to string ('true' or 'false') for reliable transmission to PHP
    formData.append('checkbox1', checkbox1 ? 'true' : 'false');
    formData.append('checkbox2', checkbox2 ? 'true' : 'false');
    formData.append('save_email', save_email);
    formData.append('product_id', product_id);
    formData.append('cust_id', cust_id);
    formData.append('saved_collection_id', saved_collection_id);
    formData.append('owner_viewing', owner_viewing);

    // Placeholder for UI feedback (you would replace console logs with actual UI updates)
    //console.log('Attempting to send data:', { text_input, checkbox1, checkbox2, save_email,product_id,cust_id,saved_collection_id });

    try {
        // 2. Make the AJAX call using the fetch API
        const response = await fetch(TARGET_URL, {
            method: 'POST',
            body: formData, // FormData handles setting the correct Content-Type header
        });

        // Check if the response was successful (HTTP status 200-299)
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // 3. Process the response (assuming the PHP script returns JSON)
        const result = await response.json();

        // 4. Handle success
       // console.log('Server response success:', result);

        if (result['status']){
          if (result['status']=='success'){
if (result['variant_id']){
add_gc_to_cart(result['variant_id'],0,0)
}else{

            if (result['message']){


  document.getElementById("modal_head").innerHTML="<br><center>"+result['message']+"<br><br></center>"; 
 
            }else{
document.getElementById("modal_head").innerHTML="<br><center>Thank you.<br><br></center>";  

            }   
     document.getElementById("modal_desc").innerHTML="";
             const xbtn = document.getElementById('xbtn');
  // Get the 'Close' button element
  const clsbtn = document.getElementById('clsbtn');

  // Check if xbtn exists before adding the click handler
  if (xbtn) {
    xbtn.onclick = sendToAccount;
  }

  // Check if clsbtn exists before adding the click handler
  if (clsbtn) {
    clsbtn.onclick = sendToAccount;
  }
              
                   document.getElementById("ynbtns").style.display="none" ; 
                    document.getElementById("closebtn").style.display="block" ; 
                    document.getElementById('atc').style.display="block";
  document.getElementById('spinner').style.display="none";
                  //toggleModal();
}
          }else{


    
 
document.getElementById("modal_head").innerHTML="<br><center>There was an error with your submission. Please try again.<br><br></center>";  

        
     document.getElementById("modal_desc").innerHTML="";
              
                   document.getElementById("ynbtns").style.display="none" ; 
                    document.getElementById("closebtn").style.display="block" ; 

const modal = document.querySelector(".pop-up-modal");
document.getElementById('atc').style.display="block";
  document.getElementById('spinner').style.display="none";

                

          }
if (!isModalVisible()) {
     toggleModal();
} 

        }

        return result; // Return the parsed response data
      

    } catch (error) {
        // 5. Handle any errors (network, parsing, or non-200 HTTP status)
        console.error('AJAX Error during process_promo:', error.message);
        // You might want to throw the error or return a structured error object here
        throw error;
    }
}

function isModalVisible() {
    return modal.classList.contains("show-pop-up");
}

function refreshPage() {
    location.reload();
  }

  function sendToAccount() {
    location.href="https://buylocalus.com/account";
  }


function check_bwp(product_id) { 
 

  var cust_id= document.getElementById('customer_number').innerHTML;
    var cust_id = cust_id.replace("<a href=\"javascript: void(0)\">", "");
    var cust_id = cust_id.replace("</a>", ""); 
var sale_type= document.getElementById('sale_type').innerHTML;

  //alert(product_id+'-'+cust_id)
 $.post("https://buylocalus.com/apps/blusapp/check_bwp.php",{cust_id:cust_id,product_id:product_id,sale_type:sale_type},function(data){
        // alert(data);
var arr=JSON.parse(data);
var points=arr['points'];
var cart_points=arr['cart_points'];   
var reason_flag=arr['reason_flag'];
var date_flag=arr['date_flag'];
var reasons=arr['reasons'];
var sold_out=arr['sold_out'];
var points_cost=arr['points_cost'];
var point_type=arr['point_type']; 
var sale_type=arr['sale_type']; 

document.getElementById('avp').innerHTML=points;
document.getElementById('points').innerHTML=points_cost;
document.getElementById('point_type').innerHTML=point_type;
document.getElementById('sale_type').innerHTML=sale_type;
   if (cart_points>0){
document.getElementById('cartp').innerHTML=cart_points;
document.getElementById('cart_points').style.display="block";     
   }

   if (data=='error' || data=='noid'){
      if (document.getElementById('na_reason')){
    document.getElementById('na_reason').innerHTML="There has been an error with this sale. Please try again later.";
     document.getElementById('na_reason').style.display="block";
      }
   }else if (sold_out==1){
      if (document.getElementById('na_reason')){
document.getElementById('na_reason').innerHTML="Sold Out";
     document.getElementById('na_reason').style.display="block";
      }
   }else{
   if (date_flag==1){
      if (document.getElementById('na_reason')){
   document.getElementById('na_reason').innerHTML="This sale has not yet started.";
     document.getElementById('na_reason').style.display="block";
      }
   }else if (date_flag==2){
      if (document.getElementById('na_reason')){
    document.getElementById('na_reason').innerHTML="This sale has ended.";
     document.getElementById('na_reason').style.display="block";
      }
   }else{

if (reason_flag>0){
   if (document.getElementById('na_reason')){
document.getElementById('na_reason').innerHTML=reasons;
document.getElementById('na_reason').style.display="block";
   }
}else{
   if (document.getElementById('bwpbtn')){
document.getElementById('bwpbtn').style.display="block";
   }
  if (document.getElementById('na_reason')){
document.getElementById('na_reason').style.display="none";
  }
}
     
   }
  		
   }  
 

 });
 
};

function buy_confirm(product_id,updating=0){

   var variant_id= document.getElementById('cur_var_id').value;
   var variant_id = variant_id.replace("<a href=\"javascript: void(0)\">", "");
    var variant_id = variant_id.replace("</a>", ""); 


 var cust_id= document.getElementById('customer_number').innerHTML;
    var cust_id = cust_id.replace("<a href=\"javascript: void(0)\">", "");
    var cust_id = cust_id.replace("</a>", ""); 
var sale_type= document.getElementById('sale_type').innerHTML;

  document.getElementById("atc").style.display="none" ;
   document.getElementById("spinner").style.display="block" ;

  //alert(product_id+'-'+cust_id)
 $.post("https://buylocalus.com/apps/blusapp/check_bwp_points.php",{cust_id:cust_id,product_id:product_id,sale_type:sale_type,variant_id:variant_id,updating:updating},function(data){
//alert(data)
    var results=data.split('^');

       var points=results[2];
       var point_type=results[1];

   document.getElementById("atc").style.display="block" ;
   document.getElementById("spinner").style.display="none" ;
      
           if (results[0]==0){
             if (results[2]==0 && results[6]==1){
              
              add_gc_to_cart(variant_id,points,point_type);
               
               
             }else{
clear_modal();
                if (results[2]==0){
              document.getElementById("modal_head").innerHTML="<center>Are you sure you wish to continue?<br><br></center>"; 
                   document.getElementById("modal_desc").innerHTML="";
                    document.getElementById('yesbtn').setAttribute('onclick','proc_bwp('+variant_id+','+product_id+','+cust_id+')');  
                   document.getElementById("ynbtns").style.display="block" ; 
                  toggleModal();
                }else{
              if (results[1]==2){
	document.getElementById("modal_head").innerHTML="<center>Use "+results[2]+" Partner Loyalty Points on this item?<br><br></center>";
                 }else if (results[1]==4) {
document.getElementById("modal_head").innerHTML="<center>Use "+results[2]+" Local Local Loyalty Points on this item?<br><br></center>";
              }else{

     document.getElementById("modal_head").innerHTML="<center>Use "+results[2]+" Discovery Points on this item?<br><br></center>";       
              }
  document.getElementById("modal_desc").innerHTML="";
               if (results[6]==1){
   document.getElementById('yesbtn').setAttribute('onclick','add_gc_to_cart('+variant_id+','+points+','+point_type+')'); 
               }else{
     document.getElementById('yesbtn').setAttribute('onclick','proc_bwp('+variant_id+','+product_id+','+cust_id+')');              
               }
   document.getElementById("ynbtns").style.display="block" ;   
	toggleModal();
             }
             }
           }else{
if (results[0]==2){
clear_modal();
             
     document.getElementById("modal_head").innerHTML="<center>This item is limited to one purchase per customer per month. You have already purchased this item in the past month.<br><br></center>";       
      document.getElementById("modal_desc").innerHTML="";
     document.getElementById("closebtn").style.display="block" ;   
	toggleModal();
  }else{
if (results[5].length>0){
 var reasons=results[5].split('|');
              var rlength=reasons.length;
              var pr_reasons="";
         
              for (var i = 0; i < rlength; i++) {
  
              var pr_reasons=pr_reasons+reasons[i]+"<br>";
         
              }
}else{
var pr_reasons="";
  
}
     
clear_modal();
       if (pr_reasons.length>0){      
     document.getElementById("modal_head").innerHTML="<center>"+pr_reasons+"<br><br></center>"; 
       }else{
      document.getElementById("modal_head").innerHTML="<center>You do not have enough points for this item.<br><br></center>";    
       }
      document.getElementById("modal_desc").innerHTML="";
     document.getElementById("closebtn").style.display="block" ;   
	toggleModal();
    
  }


             
           }

 });
  
}

function proc_bwp(variant_id,product_id,cust_id){ 
 document.getElementById("ynbtns").style.display="none" ;   
   document.getElementById("mod_spinner").style.display="block" ; 
var sale_type= document.getElementById('sale_type').innerHTML;
 $.post("https://buylocalus.com/apps/blusapp/proc_bwp.php",{cust_id:cust_id,product_id:product_id,sale_type:sale_type,variant_id:variant_id},function(data){
//alert(data)
    document.getElementById("mod_spinner").style.display="none" ; 
 if (data=='error'){
clear_modal();
         
     document.getElementById("modal_head").innerHTML="<center>There was an error with your purchase. Please try again or contact us for assistance.<br><br></center>"; 
      document.getElementById("modal_desc").innerHTML="";
     document.getElementById("closebtn").style.display="block" ;   
	
   
 }else{
clear_modal();
   
     document.getElementById("xbtn").style.display="none" ;
   document.getElementById("xbtnref").style.display="block" ;
     document.getElementById("modal_head").innerHTML="<center>"+data+"<br><br></center>"; 
      document.getElementById("modal_desc").innerHTML="";
     document.getElementById("closebtnref").style.display="block" ;
    
	
   
 }

 });
 
  
}

function refresh(){
location.reload()
  
}

